import Box from '@material-ui/core/Box'
import Divider from '@material-ui/core/Divider'
import Grid from '@material-ui/core/Grid'
import Link from '@material-ui/core/Link/Link'
import Typography from '@material-ui/core/Typography'
import VerticalAlignBottom from '@material-ui/icons/VerticalAlignBottom'
import Condition from 'pdf/smp/Konditionen_SCHUFA-Plattform.pdf'
import React, { FC, Fragment } from 'react'
import { scopedTranslation } from 'src/helpers'

import { InformationAccordion } from '../InformationAccordion/InformationAccordion'
import { useStyles } from './InformationSection.styles'

const { t } = scopedTranslation('component.smp.information_page.card')

export interface InformationAccordionOptions {
  headline: string
  link: string
  bulletPoints: string[]
}

interface InformationSectionProps {
  customerIcon: string
  customerType: string
  price: string
  infoAccordions: InformationAccordionOptions[]
  isPreview: boolean
}

export const InformationSection: FC<InformationSectionProps> = ({
  customerIcon, customerType, price, infoAccordions, isPreview,
}) => {
  const classes = useStyles()

  return (
    <Fragment>
      <Grid container={ true } alignItems='center'>
        <Grid item={ true } xs={ 12 } md={ 5 } lg={ 6 }>
          <Box display='flex' alignItems='center' my={ 3 } className={ classes.leftColumn }>
            <img src={ customerIcon } alt='' className={ classes.icon } />
            <Box flexGrow={ 1 } ml={ 2.5 }>
              <Typography variant='h3' color='textPrimary'>
                { t('headline', { customer_type: customerType }) }
              </Typography>
              <Box my={ 1 }>
                <Divider className={ classes.divider } />
              </Box>
              <Typography variant='h3' component='span' color='textPrimary'>{ t('price_a') }</Typography>
              <Typography variant='h1' component='span' color='textPrimary'>{ price }</Typography>
              <Box>
                <Typography variant='h3' component='span' color='textPrimary'>{ t('price_b') }</Typography>
              </Box>
            </Box>
          </Box>
        </Grid>
        <Grid item={ true } xs={ 12 } md={ 7 } lg={ 6 }>
          <Box className={ classes.rightColumn }>
            <Typography>
              { infoAccordions.map(infoAccordion =>
                <InformationAccordion key={ infoAccordion.headline } { ...infoAccordion } isPreview={ isPreview } />) }
            </Typography>
          </Box>
        </Grid>
      </Grid>
      { !isPreview && (
        <Box display='flex' justifyContent='flex-end'>
          <Link
            href={ Condition }
            target='_blank'
            rel='noopener noreferrer'
            underline='always'
            className={ classes.conditionLink }
          >
            <Typography><Box fontWeight='bold'>{ t('conditions') }</Box></Typography>
            <VerticalAlignBottom color='primary' />
          </Link>
        </Box>) }
    </Fragment>
  )
}
